// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1gzVn","tab":"Tabs_tab__2bYT-","tabActive":"Tabs_tabActive__2N84-"};